// extracted by mini-css-extract-plugin
export default {"size":"PrivacyPolicy_size__WQPcu"};